import React, {
  useState,
  useEffect,
  createContext,
  useRef,
  useContext
} from 'react';
import moment from 'moment';
import Helmet from 'react-helmet';
import Header from '../../common/components/Header/Header';
import Sidebar from '../../common/components/Sidebar/Sidebar';
import { siteTitle } from '../../../data/SiteConfig';
import './RmDashboard.css';
import Table from '../../components/Table/RsponsiveTable';
import AllLeadsColumnData from './AllLeadsColumnData';
import TopBarFiltersForRm from '../../components/TopbarFiltersForRm/TopbarFiltersForRm';
import { StateExporterRm } from './RmDashboard';
import { getAllLeads, getSourceList } from '../../common/constants/api';
import plusIcon from '../../images/icons/plus.svg';
import AddLeadsRmSide from '../../containers/AddLead/AddLeadRmSide/AddLeadRmSide';
import AssignMultipleLeads from './AssignMultipleLeads';
import { getFiltersInfo, setFiltersInfo } from '../../common/utils/FiltersInfo';
import LeadDashboardMobile from './AllLeadDashboardMobile/LeadDashboardMobile';
import NotificationDataContext from '../../../../lems-ui/src/common/Context/NotificationDataContext';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import Modal from '../../common/components/Modal/modal';
import DocumentCheckListLeadDashBoard from '../../common/components/DocumentCheckList/DocumentCheckListLeadDashBoard';

import Drawer from '@material-ui/core/Drawer';
import { makeStyles } from '@material-ui/core/styles';
import MessageUi from '../../components/MessageSystem/MessageUi';
import { baseUrl } from 'gatsby-env-variables';
import { maxWidth } from 'tailwindcss/defaultTheme';

const AllLeadsDashboard = () => {
  const [startDate, setStartDate] = useState(
    getFiltersInfo()?.startDate || moment().format('YYYY-MM-DD')
  );
  const notificationMessage = useContext(NotificationDataContext);
  const [endDate, setEndDate] = useState(
    getFiltersInfo()?.endDate || moment().format('YYYY-MM-DD')
  );
  const [tableInfo, setTableInfo] = useState({ size: 50 });
  const [tableLoading, setTableLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [sortColumn, setSortColumn] = useState('');
  const [sortDir, setSortDir] = useState('ASC');
  const [searchPara, setSearchPara] = useState('');
  const [filterStatus, setFilterStatus] = useState(
    getFiltersInfo()?.statusFilters || ''
  );

  const [filterProductType, setFilterProductType] = useState(
    getFiltersInfo()?.productType || ''
  );
  const productIdSetter = filterProductType => {
    if (filterProductType === 'Home Loan')
      return setFilterProductId ? setFilterProductId(1) : 1;
    if (filterProductType === 'LAP')
      return setFilterProductId ? setFilterProductId(2) : 2;
    if (filterProductType === 'PL')
      return setFilterProductId ? setFilterProductId(13) : 13;
  };
  const [filterProductId, setFilterProductId] = useState(
    productIdSetter(getFiltersInfo()?.productType) || ''
  );
  const [LeadSelectionData, setLeadSelectionData] = useState({});
  const [showAssignLeadBtn, setShowAssignLeadBtn] = useState(false);
  const assignButtonRef = useRef('');
  const [showModal, setShowModal] = useState(false);
  const [showAddLeadModal, setShowAddLeadModal] = useState(false);
  const [showAddlead, setAddLead] = useState(false);
  const [rmId, setRmId] = useState(getFiltersInfo()?.rmId || '');
  const [statusFiltersList, setStatusFilterList] = useState([]);
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(50);
  const [firstloading, setFirstLoading] = useState(true);
  const [source, setSource] = useState(getFiltersInfo()?.sourceFilter || '');
  const [sourceList, setSourceList] = useState([]);
  const [render, setRender] = useState(false);
  const [doLoad, setDoLoad] = useState(false);
  const [userDataForWA, setUSerDataForWA] = useState({});
  const [showWhatsApp, setShowWhatsApp] = useState(false);
  const [showWhatsAppCheckList, setShowWhatsAppCheckList] = useState(false);
  const [currentApplicantId, setCurrentApplicantId] = useState(null);
  const [CurrDocleadId, setCurrDocLeadId] = useState(true);
  const customHandlePageChange = async page => {
    setPage(page - 1);
  };

  const customHandleSort = async (column, sortDirection) => {
    setSortColumn(column?.selector || '');
    setSortDir(sortDirection);
  };

  const customHandleSearch = () => {};

  const customHandlePerRowsChange = (perPage, page) => {
    setSize(perPage);
    setPage(0);
  };

  const CustomhandleSearch = seachParameter => {
    setSearchPara(seachParameter);
  };
  const useStyles = makeStyles({
    root: {
      ['@media (max-width:768px)']: {
        width: '100%',
        marginTop: '9vh',
        height: '91vh'
      },
      ['@media (min-width:769px)']: {
        width: '500px'
      }
    }
  });
  const classes = useStyles();

  const getLeadData = () => {
    setTableLoading(true);
    getAllLeads(
      startDate,
      endDate,
      page,
      size,
      searchPara,
      sortColumn,
      sortDir,
      filterStatus,
      rmId,
      filterProductId,
      source
    )
      .then(res => {
        setTableData(res?._embedded?.customers || []);
        setTableInfo(res.page);
        setTableLoading(false);
        setFirstLoading(false);
      })
      .catch(err => {
        setFirstLoading(false);
      });
  };

  useEffect(() => {
    getLeadData();
  }, []);

  useEffect(() => {
    if (!firstloading) getLeadData();
  }, [page]);

  useEffect(() => {
    if (!firstloading) getLeadData();
  }, [rmId]);

  useEffect(() => {
    if (!firstloading) getLeadData();
  }, [size]);

  useEffect(() => {
    if (!firstloading) getLeadData();
  }, [
    startDate,
    endDate,
    sortColumn,
    sortDir,
    searchPara,
    filterProductId,
    filterStatus,
    source
  ]);
  useEffect(() => {
    if (filterProductType) {
      productIdSetter(filterProductType);
    } else setFilterProductId('');
  }, [filterProductType]);

  const filters = () => [
    {
      name: 'Status',
      type: 'check',
      dropdown: [
        {
          htmlTitle: <span className="text-blue-1101">Open</span>,
          title: 'Open',
          checked: filterStatus?.split(',')?.includes('Open') ? true : false
        },
        {
          title: 'Follow Up',
          htmlTitle: <span className="text-orange-1000">Follow Up</span>,

          checked: filterStatus?.split(',')?.includes('Follow Up')
            ? true
            : false
        },
        {
          title: 'Interested',
          htmlTitle: <span className="text-green-1100">Interested</span>,

          checked: filterStatus?.split(',')?.includes('Interested')
            ? true
            : false
        },
        {
          title: 'Not Interested',
          htmlTitle: <span className="text-black-950"> Not Interested</span>,
          checked: filterStatus?.split(',')?.includes('Not Interested')
            ? true
            : false
        },

        {
          title: 'Lead Rejected',
          htmlTitle: <span className="text-red-500">Lead Rejected</span>,
          checked: filterStatus?.split(',')?.includes('Lead Rejected')
            ? true
            : false
        }
      ]
    },
    {
      name: 'Product',
      type: 'check',
      dropdown: [
        {
          htmlTitle: <span className="text-blue-1101">Home Loan</span>,
          title: 'Home Loan',
          checked: filterProductType === 'Home Loan'
        },
        {
          title: 'LAP',
          htmlTitle: <span className="text-orange-1000">LAP</span>,
          checked: filterProductType === 'LAP'
        },
        {
          title: 'PL',
          htmlTitle: <span className="text-green-1100">PL</span>,
          checked: filterProductType === 'PL'
        }
      ]
    }
  ];
  useEffect(() => {
    let new_array = filters();

    if (sourceList?.length > 0 && new_array?.length == 2) {
      new_array.push({
        name: 'Source',
        type: 'check',
        dropdown: sourceList,
        singleSelect: true
      });
    }
    setStatusFilterList(new_array);
    setRender(!render);
  }, [filterStatus, filterProductType, sourceList, source, doLoad]);

  const leftSideHeaderComoponent = () => {
    return (
      <div className="">
        <button
          type="button"
          onClick={() => setShowModal(true)}
          className="px-3 py-2 rounded border border-orange-200 text-orange-200 text-xs font-roboto w-37 hidden"
          ref={assignButtonRef}
        >
          Assign leads
        </button>
      </div>
    );
  };
  useEffect(() => {
    let style = assignButtonRef?.current?.style;
    if (!style) return;
    if (showAssignLeadBtn) style.visibility = 'visible';
    else style.visibility = 'hidden';
  }, [showAssignLeadBtn]);

  useEffect(() => {
    let filterList = getFiltersInfo();
    if (typeof filterList == 'object') {
      filterList['statusFilters'] = filterStatus;
      setFiltersInfo(filterList);
    } else {
      setFiltersInfo({
        statusFilters: filterStatus
      });
    }
  }, [filterStatus]);

  const getSourceData = () =>
    getSourceList()
      .then(res => {
        if (res?.error) throw new Error(res);
        setSourceList(
          res?.map(each => {
            return {
              htmlTitle: (
                <span className="text-blue-1101">{each?.displayName}</span>
              ),
              title: `${each?.id}`,
              checked:
                getFiltersInfo()?.sourceFilter?.toString() == `${each?.id}`
                  ? true
                  : false
            };
          })
        );
      })
      .catch(error => {});

  useEffect(() => {
    getSourceData();
  }, []);

  useEffect(() => {
    setFiltersInfo({
      ...(getFiltersInfo() || {}),
      sourceFilter: source?.toString()
    });
    setSourceList(
      sourceList?.map(each => {
        return {
          htmlTitle: each?.htmlTitle,
          title: each?.title,
          checked: source?.toString() == each?.title
        };
      })
    );
    setDoLoad(!doLoad);
  }, [source]);

  const getAllFilters = data => {
    if (!data?.Source) return setSource('');
    setSource(
      Object?.keys(data?.Source)
        ?.filter(each => data?.Source[each])
        ?.toString()
    );
  };
  useEffect(() => {
    setRender(!render);
  }, [statusFiltersList, sourceList, filterProductType, filterStatus]);
  return (
    <>
      <Helmet title={`Dashboard RM | ${siteTitle}`} />
      <div className="bg-grey-950 relative h-full overflow-auto font-roboto text-sm font-normal m-0 p-0">
        <div className=" min-h-screen flex pt-17 md:pt-0 ">
          <Sidebar />
          <div className="widhtMd  max-screen flex-1  w-full ">
            <Header />
            <DocumentCheckListLeadDashBoard
              showWhatsAppCheckList={showWhatsAppCheckList}
              setShowWhatsAppCheckList={setShowWhatsAppCheckList}
              leadId={CurrDocleadId}
              currentApplicantId={currentApplicantId}
            />
            <div className="md:hidden">
              <LeadDashboardMobile
                data={tableData}
                setStartDate={setStartDate}
                setEndDate={setEndDate}
                setSource={setSource}
                setFilterStatus={setFilterStatus}
                setFilterProductId={setFilterProductId}
                setRmId={setRmId}
                tableLoading={tableLoading}
                tableInfo={tableInfo}
                setPage={setPage}
                setSearchPara={setSearchPara}
                getLeadData={getLeadData}
                setShowWhatsApp={setShowWhatsApp}
                setUSerDataForWA={setUSerDataForWA}
                showSendDoc={showWhatsAppCheckList}
                setShowSendDoc={setShowWhatsAppCheckList}
              />
            </div>
            <Drawer
              anchor="right"
              open={showWhatsApp}
              onClose={() => setShowWhatsApp(false)}
              onOpen={() => setShowWhatsApp(true)}
              classes={{ paper: classes.root }}
            >
              <div className={`w-full `}>
                <MessageUi
                  baseUrl={baseUrl}
                  applicantInfo={userDataForWA?.applicantInfo}
                  setShowWhatsApp={setShowWhatsApp}
                  userData={userDataForWA}
                />
              </div>
            </Drawer>
            <div className="hidden md:block">
              <StateExporterRm.Provider
                value={{
                  startDate,
                  setStartDate,
                  endDate,
                  setEndDate,
                  productFilter: true,
                  setFilterProductType
                }}
              >
                <TopBarFiltersForRm hideBpBtn={true} hideAddLeadBtn={true} />
                <div className="w-full text-right">
                  <button
                    className=" w-48 h-12 mr-3 mt-2 cursor-pointer text-center text-white bg-tealCol-100 rounded-md ml-auto"
                    onClick={() => {
                      setShowAddLeadModal(true), setAddLead(true);
                    }}
                  >
                    <div className="mx-auto inline-flex ">
                      <img
                        className="block mr-2 -mt-px "
                        src={plusIcon}
                        alt="+"
                      />
                      <span className="text-base py-3 block">Add Lead</span>
                    </div>
                  </button>
                </div>
                {showAddlead ? (
                  <AddLeadsRmSide
                    showModal={showAddLeadModal}
                    setShowModal={setShowAddLeadModal}
                    setAddLead={setAddLead}
                    onAddLeadAdded={getLeadData}
                  />
                ) : null}
                <div className="test w-full">
                  <Table
                    Search=""
                    data={tableData}
                    StatusOPtion={[]}
                    columns={AllLeadsColumnData(
                      LeadSelectionData,
                      setLeadSelectionData,
                      setShowAssignLeadBtn,
                      getLeadData,
                      notificationMessage,
                      setShowWhatsApp,
                      setUSerDataForWA,
                      setCurrentApplicantId,
                      setShowWhatsAppCheckList,
                      setCurrDocLeadId
                    )}
                    serverPagination={true}
                    CustomhandlePerRowsChange={(perPage, page) =>
                      customHandlePerRowsChange(perPage, page)
                    }
                    CustomhandlePageChange={customHandlePageChange}
                    CustomhandleSort={customHandleSort}
                    CustomhandleSearch={customHandleSearch}
                    serverSort={true}
                    TableInfo={tableInfo}
                    tableLoading={tableLoading}
                    filterComponent={true}
                    GetLeadStatus={statusFiltersList}
                    serchBarPlaceHolder="Search Customer"
                    filterCaption="Filter"
                    rows="50"
                    tableListbelongs="Leads"
                    startDate={startDate}
                    endDate={endDate}
                    page={tableInfo?.number?.toString() || 0}
                    CustomhandleSearch={CustomhandleSearch}
                    searchUrl={true}
                    setFilterStatus={setFilterStatus}
                    filterStyle={{ marginRight: 'auto', width: 'auto' }}
                    searchStyle={{ position: 'relative' }}
                    showNumberOfListStyle={{ display: 'none' }}
                    leftSideHeaderComoponent={leftSideHeaderComoponent}
                    setRmId={setRmId}
                    rmId={rmId}
                    rm={true}
                    filterContanier="lg:mr-auto mr-auto table mx-2 -ml-2 "
                    StatusFilter={filterStatus}
                    filteredObject={getAllFilters}
                    render={render}
                  />
                </div>
                {showModal ? (
                  <AssignMultipleLeads
                    showModal={showModal}
                    setShowModal={setShowModal}
                    LeadSelectionData={LeadSelectionData}
                  />
                ) : null}
              </StateExporterRm.Provider>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withErrorHandler(AllLeadsDashboard);
